module.exports = __webpack_public_path__ + "img/图片13.05cbe5fa.png";